<template>
  <div class="companyPoster" @click.self="hide()" v-if="show_view">
    <div class="companyPosterContainer">
      <div class="leftView">
        <iframe
          class="poster"
          id="poster"
          name="poster"
          :src="poster_url"
          frameborder="0"
        ></iframe>
      </div>
      <div class="rightView">
        <div id="qrcode" ref="qrcode"></div>
        <p class="content">
          打开手机，扫描二维码<br />用手机打开海报，分享至朋友圈，<br />邀请好友加入你的公司吧~~
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import QRCode from "qrcodejs2";
import { Utils } from "../utils";

export default {
  name: "CompanyMember",
  components: {},
  props: {},
  data() {
    return {
      show_view: false,
      poster_url: ""
    };
  },
  watch: {},
  computed: {},
  methods: {
    show(company_id) {
      let host = "";
      if (location.host.includes("coding61.com")) {
        host = "www.coding61.com";
      } else {
        host = "app.bcjiaoyu.com";
      }
      let url = `https://${host}/face2face/web/companyPoster/index.html?company_id=${company_id}`;
    //   url = `https://www.coding61.com/face2face/web/companyPoster/index.html?company_id=1`;
      console.log(url);
      this.show_view = true;
      this.poster_url = url;

      this.$nextTick(()=>{
          this.qrcode()
      })
      
    },
    hide() {
        this.$refs.qrcode.innerHTML = ''
        this.show_view = false;
    },
    qrcode() {
      let qrcode = new QRCode("qrcode", {
          width:150,
          height:150,
        text: this.poster_url, // 二维码地址
        // colorDark: "#000",
        // colorLight: "#fff"
      });
    }
  },
  created() {},
  destroyed() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.companyPoster {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .companyPosterContainer {
    width: 60%;
    height: 70%;
    overflow: auto;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    padding: 20px;
    .leftView {
      width: 50%;
      height: 100%;
      margin-right: 20px;
      iframe {
        width: 100%;
        height: 100%;
        background-color: #f2f2f2;
      }
    }
    .rightView {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      .qrcode {
        width: 100px;
        height: 100px;
        margin-bottom: 20px;
        margin-top: 20px;
      }
      #qrcode{
        margin-bottom: 20px;
        margin-top: 20px;
      }
      .content {
        color: #333333;
        font-size: 15px;
        line-height: 30px;
      }
    }
  }
}
</style>
